// toastManager.js
let subscribers = [];
let queue = [];

export const toastManager = {
  subscribe(callback) {
    subscribers.push(callback);
    callback(queue); // ارسال initial state
  },
  unsubscribe(callback) {
    subscribers = subscribers.filter(cb => cb !== callback);
  },
  add(msg, type = "error", duration = 3000) {
    if (queue.some(item => item.msg === msg)) return;

    const toastObj = {
      id: Date.now(),
      msg,
      type,
      duration
    };

    queue.push(toastObj);
    subscribers.forEach(cb => cb([...queue]));

    setTimeout(() => {
      queue = queue.filter(t => t.id !== toastObj.id);
      subscribers.forEach(cb => cb([...queue]));
    }, duration);
  }
};
